module.exports = __webpack_public_path__ + "img/ZIP.66d4eb7.svg";